import { createFeatureSelector, createSelector } from '@ngrx/store';
import { adapter, DataTypeState } from './data-type.reducer';

export const selectDataTypeState = createFeatureSelector<DataTypeState>('dataTypes');

export const { selectAll: selectAllDataTypes } = adapter.getSelectors(selectDataTypeState);

export const selectDataTypes = selectAllDataTypes;
export const selectDataTypeLoading = createSelector(selectDataTypeState, (state) => state.loading);
